import React from 'react';
import { CONTRACT_LABELS, type ContractType } from '../../lib/appointmentLifecycle';

/**
 * Pastille de type de contrat — libellé piloté par CONTRACT_LABELS (contrat partagé,
 * jamais de texte en dur). null = type inconnu (calibrage non renseigné).
 */
const ContractBadge: React.FC<{ contractType: ContractType | null; className?: string }> = ({
  contractType,
  className = '',
}) => {
  // Type inconnu (calibrage non renseigné) → on n'affiche rien plutôt qu'un « Contrat inconnu » parasite.
  if (!contractType) return null;
  const label = CONTRACT_LABELS[contractType];
  return (
    <span
      title={label}
      className={`inline-flex items-center font-mono text-[10px] font-semibold px-2 py-0.5 rounded-md uppercase tracking-wide bg-raise text-dim ${className}`}
    >
      {label}
    </span>
  );
};

export default ContractBadge;
